const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function AntivirusSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Antivirus', item: `${SITE_URL}/antivirus` },
    ],
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Antivirus Originales Colombia - Digital Licence Store',
    url: `${SITE_URL}/antivirus`,
    numberOfItems: 10,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'Kaspersky Premium 5 Dispositivos - 1 año',
          description: 'Protección premium completa Kaspersky para 5 dispositivos durante 1 año.',
          url: `${SITE_URL}/antivirus`,
          brand: { '@type': 'Brand', name: 'Kaspersky' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '305200',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/antivirus`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '280', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'Kaspersky Standard 5 Dispositivos - 1 año',
          description: 'Protección esencial Kaspersky para 5 dispositivos durante 1 año.',
          url: `${SITE_URL}/antivirus`,
          brand: { '@type': 'Brand', name: 'Kaspersky' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '229450',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/antivirus`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '45', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Product',
          name: 'McAfee Total Protection 5 Dispositivos - 1 año',
          description: 'Protección total McAfee para 5 dispositivos durante 1 año.',
          url: `${SITE_URL}/antivirus`,
          brand: { '@type': 'Brand', name: 'McAfee' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '281750',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/antivirus`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '121', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@type': 'Product',
          name: 'ESET NOD32 Antivirus 5 Dispositivos - 2 años',
          description: 'Antivirus ESET NOD32 para 5 dispositivos durante 2 años.',
          url: `${SITE_URL}/antivirus`,
          brand: { '@type': 'Brand', name: 'ESET' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '339250',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/antivirus`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '204', bestRating: '5' },
        },
      },
    ],
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Antivirus Originales Colombia - Kaspersky, McAfee, ESET | Digital Licence Store',
    description: 'Compra antivirus originales Kaspersky, McAfee y ESET NOD32 al mejor precio en Colombia. Descuentos hasta 58%. Entrega inmediata por email.',
    url: `${SITE_URL}/antivirus`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
